import styled from "@emotion/styled";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import React from "react";

const RadioGroup = () => <></>;

RadioGroup.Root = styled(RadioGroupPrimitive.Root)``;
RadioGroup.Indicator = styled(RadioGroupPrimitive.Indicator)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  &::after {
    --size: 14px;
    content: "";
    display: block;
    width: var(--size);
    height: var(--size);
    border-radius: 50%;
    background-color: var(--primary-color);
  }
`;
RadioGroup.ItemRoot = styled(RadioGroupPrimitive.Item)`
  --size: 24px;
  width: var(--size);
  height: var(--size);
  background-color: white;
  border-radius: 100%;
  border: 2px solid rgba(55, 120, 224, 0.25);

  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
RadioGroup.Item = (
  props: React.ComponentProps<typeof RadioGroup.ItemRoot> & {
    radioRef?: React.Ref<HTMLButtonElement>;
  }
) => (
  <RadioGroup.ItemRoot {...props} ref={props.radioRef}>
    <RadioGroup.Indicator />
  </RadioGroup.ItemRoot>
);

export default RadioGroup;
